import React, { useContext, useEffect, useReducer, useMemo } from 'react';
import { lockedReducer } from '../Utils/reducers';
import { api } from '../../services/api';
import { Box, IconButton, Tooltip, TextField } from '@mui/material';
import ColorButton from '../Buttons/ColorButton';
import Table, { TableHook } from '../Table';
import { externalComponent } from '../AppRoutes';
import { convertDateFormat } from '../Utils/functions';
import { number2dayweek } from '../Utils/dayjsptbrhelper';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import toast from 'react-hot-toast';
import { validateDateRange } from '../Utils/functions';

const url = '/eventos/'


const columns = (setState) => {
    return [
        { field: 'ticket_cartao', headerName: 'Ticket / Cartão', flex: 1, filterType: 'string' },
        { field: 'nome', headerName: 'Nome', flex: 2, filterType: 'string' },
        { field: 'ala', headerName: 'Ala', flex: 1, filterType: 'string' },
        { field: 'piso', headerName: 'Piso', flex: 1, filterType: 'string' },
        { field: 'catraca', headerName: 'Catraca', flex: 1, filterType: 'string' },
        { field: 'chuveiro', headerName: 'Chuveiro', flex: 1, filterType: 'string' },
        { field: 'entrada_saida', headerName: 'Entrada / Saída', flex: 1, filterType: 'string' }
    ]
}

const setInicialDate = (date, setState) => {
    if (!date) {
        setState({ dtIni: null })
        return
    }

    setState({ dtIni: date.format('YYYY-MM-DD') })
}

const setFinalDate = (date, setState) => {
    if (!date) {
        setState({ dtFim: null })
        return
    }

    setState({ dtFim: date.format('YYYY-MM-DD') })
}

const generateExcel = async (setLoader, state) => {
    const body = {
        dtIni: state.dtIni,
        dtFim: state.dtFim
    };

    if (validateDateRange(state.dtIni, state.dtFim, toast)) {
        return
    }

    setLoader(true);
    try {
        const res = await api.post(`${url}generate_excel/`, body, {
            responseType: 'blob'
        });

        if (res.status === 200) {
            // Gera nome dinâmico: relatorio-16-06-2025.xlsx
            const now = new Date();
            const dia = String(now.getDate()).padStart(2, '0');
            const mes = String(now.getMonth() + 1).padStart(2, '0');
            const ano = now.getFullYear();
            const filename = `relatorio-${dia}-${mes}-${ano}.xlsx`;

            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } else if (res.status === 404) {
            toast.error('Nenhum evento encontrado no intervalo.')
        } else {
            toast.error('Erro ao gerar Excel.');
        }

    } catch (error) {
        console.error('Erro ao gerar Excel:', error);
        toast.error('Erro ao gerar Excel.');
    } finally {
        setLoader(false);
    }
};

const consultEvents = async (setLoader, state, setState) => {

    const body = {
        dtIni: state.dtIni,
        dtFim: state.dtFim
    };

    setLoader(true)
    const res = await api.post(`${url}consult_events/`, body)
    if (res.status === 200) {
        const data = res.data.data
        setState({ rows: data })
    } else {
        console.log(res)
        toast.error(res.data.error)
    }
    setLoader(false)

}

const RelatoriosIndex = () => {

    const currentDate = new Date();
    const threeMonthsAgo = new Date();

    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 1);

    threeMonthsAgo.setDate(1);

    const dtIni = convertDateFormat(threeMonthsAgo)
    const dtFim = convertDateFormat(currentDate)


    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        rowsReset: [],
        dtIni: dtIni,
        dtFim: dtFim

    })

    const { setLoader } = useContext(externalComponent)

    const [table, reloadTable] = TableHook()

    useEffect(() => {

        consultEvents(setLoader, state, setState)

    }, [])

    return (
        <>
            <Box className='information-table nfsentrada-mainframe'>
                <Box className='nfsentrada-filters'>
                    <Box className='filter-items'>


                        <Box className='item-profile-row' sx={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                            <DemoContainer components={['DatePicker']}>
                                <DatePicker
                                    slotProps={{ textField: { size: 'small' } }}
                                    label="Dt Eventos Inicial:"
                                    size="small"
                                    value={state.dtIni ? dayjs(state.dtIni) : null}
                                    onChange={(e) => setInicialDate(e, setState)}
                                    format='DD/MM/YYYY'
                                    dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                />
                            </DemoContainer>

                            <DemoContainer components={['DatePicker']}>
                                <DatePicker
                                    slotProps={{ textField: { size: 'small' } }}
                                    label="Dt Eventos Final:"
                                    size="small"
                                    value={state.dtFim ? dayjs(state.dtFim) : null}
                                    onChange={(e) => setFinalDate(e, setState)} format='DD/MM/YYYY'
                                    dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                />
                            </DemoContainer>

                        </Box>

                    </Box>
                    <Box className='filter-buttons'>
                        <ColorButton endIcon={<ArrowCircleDownIcon />} onClick={() => generateExcel(setLoader, state)} >Baixar relatório</ColorButton>
                        <ColorButton onClick={() => consultEvents(setLoader, state, setState)} >Localizar</ColorButton>
                    </Box>
                </Box>


                <Box className='user-table' sx={{ backgroundColor: '#ffffff' }}>
                    <Table
                        rows={state.rows}
                        columns={useMemo(() => columns(setState))}
                        pagination
                        density='compact'
                        toolbar
                        getURL={'teste'}
                        updateRows={(rows) => setState({ 'rows': rows })}
                        innerRef={table}
                        hideFooter
                    />
                </Box>
            </Box>
        </>
    )
}

export default RelatoriosIndex;  